import React, {Component} from 'react'
import Target from '../Target.svg'
import Loving_Story from '../Loving_Story.svg'
import Winners from '../Winners.svg'
import ContactForm from "../Contact/ContactForm";

class Hero extends Component {
    render() {
        const descColor = "#6C63FF";

        return (
            <div>
                <div id="heroText">
                    <h1 id="heroTextHeader"><i className="fas fa-book-reader" /> UNIQUE TUTORIALS</h1>
                    <h3 style={{marginTop: '-15px'}}>Tutoring Company in New Jersey & Online</h3>
                    <p style={{marginTop: '-15px'}}><i>Serving Essex, Union, Somerset, Middlesex, Mercer and Monmouth Counties</i></p>
                    <p style={{marginTop: '-15px', color: "#5c5c5c"}}><i>Lessons also taught via Skype</i></p>
                </div>
                <br/><br/>
                <div id="heroIllustrations">
                    <div>
                        <div className="card-hover hero-feature">
                            <h3>High Quality</h3>
                            <img src={Winners} width="150px" height="150px" alt="UniqueTutorials1"/>
                            <p style={{color: descColor}}>Experienced Tutors in their fields. In both Academic and Industry Settings</p>
                        </div>
                    </div>
                    <div>
                        <div className="card-hover hero-feature">
                            <h3>Results Oriented</h3>
                            <img src={Target} width="150px" height="150px" alt="UniqueTutorials2"/>
                            <p style={{color: descColor}}>We focus on delivering results. Improving Scores, Grades & Competency</p>
                        </div>
                    </div>
                    <div>
                        <div className="card-hover hero-feature">
                            <h3>Compassionate</h3>
                            <img src={Loving_Story} width="150px" height="150px" alt="UniqueTutorials3"/>
                            <p style={{color: descColor}}>We understand every person is unique and tailor our teaching to the student</p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <div id="heroContact">
                    <div id="heroContactInfo"  className="card">
                        <h1 style={{textAlign: 'center', color: 'white'}}>GET STARTED TODAY<span role="img" aria-label="envelope"> ️✉️</span>️</h1>
                        <div id="heroContactInfoForm">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Hero